<template>

    <modal :show="showModal">

        <div class="mcp__modal">

            <div class="mcp__header">

                <h2 class="mcp__header-title">{{ $t('custom_cookies_title') }}</h2>

            </div>

            <div class="mcp__divider"></div>

            <div class="mcp__content-container">

                <div class="mcp__subtitle-container">

                    <p class="mcp__subtitle">{{ $t('custom_cookies_required_cookies') }}</p>

                    <div class="mcp__tag">{{ $t('custom_cookies_mandatory') }}</div>

                </div>

                <p class="mcp__text mt__10">{{ $t('custom_cookies_description_1') }}</p>

                <div class="mcp__green__more-container mt__8" @click="toggleNecessary">

                    <p class="mcp__green__text-green">{{ computedShowMoreNecessary }}</p>

                    <img :class="{'mcp__green__arrow-less': showNecessary}" class="mcp__green__arrow-more"
                         src="/img/icons/arrow-green.svg">

                </div>

                <div>
                    <template v-for="(item) in necessary" v-if="showNecessary">

                        <div class="mcp__item__container">

                            <div class="mcp__item__header">
                                <div class="mcp__item__header-left">

                                    <img v-if="item.list" :class="{'mcp__item__arrow-reverse': item.listOpen}"
                                         class="mcp__item__arrow" src="/img/icons/arrow-black.svg"
                                         @click="toggleList('necessary', item.name)">
                                    <p class="mcp__item__title">{{ getTitle(item.title, item.name) }}</p>
                                </div>

                                <div class="mcp__tag">{{ $t('custom_cookies_mandatory') }}</div>
                            </div>

                            <div class="mcp__item__content">
                                <p class="mcp__item__text">{{ getDescription(item.description) }}</p>
                                <p class="mcp__item__text" v-if="item.since">{{
                                        $tc('custom_cookies_accept_date', 0, {
                                            date: getDate(item.since),
                                            month_duration: '13'
                                        })
                                    }}</p>
                            </div>

                            <div v-if="item.listOpen" class="mcp__list__content">

                                <p v-for="(key, index) in item.list" class="mcp__list__text">{{ item.list[index] }}</p>

                            </div>

                        </div>

                    </template>

                </div>

            </div>

            <div class="mcp__divider"></div>

            <div class="mcp__content-container">

                <div class="mcp__subtitle-container">

                    <p class="mcp__subtitle">{{ $t('custom_cookies_optional_cookies') }}</p>

                    <checkbox-circle :state="checkboxState" @change="updateAllCookies"></checkbox-circle>

                </div>

                <p class="mcp__text mt__10">{{ $t('custom_cookies_description_2') }}</p>

                <div class="mcp__green__more-container mt__8" @click="toggleOptional">

                    <p class="mcp__green__text-green">{{ computedShowMoreOptional }}</p>

                    <img :class="{'mcp__green__arrow-less': showOptional}" class="mcp__green__arrow-more"
                         src="/img/icons/arrow-green.svg">

                </div>

                <div>
                    <template v-for="(option, index) in optional" v-if="showOptional">

                        <div class="mcp__item__container">

                            <div class="mcp__item__header">
                                <div class="mcp__item__header-left">
                                    <img v-if="option.list" :class="{'mcp__item__arrow-reverse': option.listOpen}"
                                         class="mcp__item__arrow" src="/img/icons/arrow-black.svg"
                                         @click="toggleList('optional', option.name)">
                                    <p class="mcp__item__title">{{ getTitle(option.title, option.name) }}</p>
                                </div>

                                <checkbox-circle :state="option.active"
                                                 @change="updateOneCookie($event, index)"></checkbox-circle>
                            </div>

                            <div class="mcp__item__content">
                                <p class="mcp__item__text">{{ getDescription(option.description) }}</p>
                                <p class="mcp__item__text" v-if="option.since">{{
                                        $tc('custom_cookies_accept_date', 0, {
                                            date: getDate(option.since),
                                            month_duration: '13'
                                        })
                                    }}</p>
                            </div>

                            <div v-if="option.listOpen" class="mcp__list__content">

                                <p v-for="(key, index) in option.list" class="mcp__list__text">{{
                                        option.list[index]
                                    }}</p>

                            </div>

                        </div>

                    </template>

                </div>

            </div>

            <div class="mcp__footer__container">

                <button class="btn btn-green btn-big mcp__footer__btn" @click="update">{{
                        $t('custom_cookies_cta')
                    }}
                </button>

            </div>

        </div>

    </modal>

</template>

<script>
import Api from '../../api'
import Tag from '../../modules/tag'

import Checkbox from '../../components/inputs/Checkbox'
import Modal from '../../components/modal/Modal'
import CheckboxCircle from '../../components/inputs/CheckboxCircle'

import Storage from '../../helpers/storage'

export default {

    name: 'modal-cookies-policy',

    components: {CheckboxCircle, Checkbox, Modal},

    computed: {

        computedShowMoreNecessary: function () {
            return this.showNecessary ? this.$t('custom_cookies_less_info') : this.$t('custom_cookies_more_info')
        },

        computedShowMoreOptional: function () {
            return this.showOptional ? this.$t('custom_cookies_less_info') : this.$t('custom_cookies_more_info')
        }

    },

    data() {
        return {
            showModal: false,
            showNecessary: false,
            showOptional: false,
            necessary: [],
            optional: [],
            checkboxState: false
        }
    },

    methods: {

        open() {

            this.initPreferences()
            this.showModal = true
        },

        closeModal() {

            this.showModal = false
            this.$emit('close', this.shared)
        },

        toggleNecessary() {
            this.showNecessary = !this.showNecessary
        },

        toggleOptional() {
            this.showOptional = !this.showOptional
        },

        toggleList(listArray, name) {

            this[listArray].forEach(item => {
                if (name === item.name) {
                    item.listOpen = !item.listOpen
                }
            })

            this.$forceUpdate()
        },

        getTitle(lkTitle, defaultName) {
            return this.$te(lkTitle)
                ? this.$t(lkTitle)
                : defaultName
        },

        getDescription(lkDescription) {
            return this.$te(lkDescription)
                ? this.$t(lkDescription)
                : ''
        },

        getDate(time) {
            return new Date(time).toLocaleDateString()
        },

        updateAllCookies(bool) {
            this.optional.forEach(item => item.active = bool)
            Tag.clickGA(this, 'switch_consent', undefined, bool ? 1 : 0)
        },

        updateOneCookie(bool, index) {
            this.optional[index].active = bool
        },

        update() {

            const result = [...this.necessary, ...this.optional]

            Tag.updateCookies(result)
            Tag.clickGA(this, 'click_update')

            this.closeModal()
        },

        initPreferences() {
            const preferences = Storage.getItem('cookieLawPreferences')

            Api.user.getCookiesList(this)
                .then(cookies => {

                    let allCookies = cookies

                    if (preferences) {

                        const preferencesCookies = JSON.parse(preferences)

                        const tempArray = []
                        for (const indexA in allCookies) {
                            let shared = false
                            for (const indexP in preferencesCookies) {
                                if (preferencesCookies[indexP].name === allCookies[indexA].name) {
                                    shared = true
                                    break
                                }
                            }
                            if (!shared) {
                                tempArray.push(allCookies[indexA])
                            }
                        }
                        allCookies = tempArray.concat(preferencesCookies)
                    }

                    this.necessary = allCookies.filter(item => item.necessary)
                    this.optional = allCookies.filter(item => !item.necessary)


                    this.checkboxState = this.optional.filter(item => item.active).length > 0
                })
                .catch(() => {
                    // TODO: what to do if we can't retrieve the cookies list
                })

        }
    }

}


</script>

<style lang="scss" scoped>

.mcp {

    &__modal {
        position: relative;
        max-height: 70vh;
        overflow: scroll;
        @media screen and (min-width: $above-mobile-length) {
            max-height: 90vh;
            max-width: 480px;
        }
    }

    &__header {
        padding: 24px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    &__header-title {
        font-size: 17px;
        font-weight: bold;
        line-height: 1.41;
        text-align: start;
        color: $charcoal;
    }

    &__divider {
        height: 1px;
        width: 100%;
        background-color: rgba(17, 17, 26, 0.1);
    }

    &__content-container {
        margin: 26px 24px 24px;
    }

    &__subtitle-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    &__subtitle {
        font-size: 17px;
        font-weight: 600;
        line-height: 1.18;
        text-align: start;
        color: $charcoal;
    }

    &__tag {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 8px;
        background-color: #f9fafc;
        border-radius: 64px;
        font-size: 12px;
        font-weight: 600;
        line-height: 1.33;
        letter-spacing: 0.12px;
        color: $stone;
    }

    &__text {
        font-size: 15px;
        line-height: 1.33;
        text-align: start;
        color: $neutralsMoon;
    }

    &__green {

        &__more-container {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
        }

        &__text-green {
            font-size: 15px;
            font-weight: 500;
            line-height: 1.33;
            text-align: start;
            color: $forest;
        }

        &__arrow-more {
            width: 18px;
            object-fit: contain;
            transform: rotate(270deg);
            margin-left: 2px;
        }

        &__arrow-less {
            transform: rotate(90deg);
        }
    }

    &__item {

        &__container {
            margin-top: 20px;
        }

        &__header {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }

        &__header-left {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }

        &__arrow {
            width: 16px;
            object-fit: contain;
            margin-right: 4px;
            transform: rotate(270deg);
            cursor: pointer;
        }

        &__arrow-reverse {
            transform: rotate(90deg);
        }

        &__title {
            font-size: 15px;
            font-weight: 500;
            line-height: 1.33;
            text-align: start;
            color: $charcoal;
        }

        &__content {
            margin-top: 6px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
        }

        &__text {
            color: $neutralsMoon;
            text-align: start;
            margin-top: 4px;
        }
    }

    &__footer {

        &__container {
            position: sticky;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: $white;
            padding: 24px;
            border-top: 1px solid rgba(17, 17, 26, 0.1);
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
        }

        &__btn {
            background-color: $forest;
        }

    }

    &__list {
        &__content {
            margin-top: 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            border-left: 4px solid #e7e7e8;
        }

        &__text {
            margin-left: 16px;
            margin-top: 8px;
            font-size: 12px;
            font-weight: 600;
            line-height: 1.33;
            text-align: start;
            color: $charcoal;
        }
    }
}

</style>
